import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

const AddSTockPrice = (props) => {
    console.log(props , 'props check edi stsdiosahdjah')

    return (
        <div>
            <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {props.messageAddModal && props.messageAddModal ?
                <p style={{color : 'green' , fontSize : 14}}>{props.messageAddModal}</p> : ''    
            }
                <Form.Label>Sizes</Form.Label>
                <Form.Select aria-label="Default select example" 
                onChange={(e) => props.setProductDetails({...props.productDetails , size_id:e.target.value})}>
                        <option disabled selected> Select Product Size</option>
                        {props.productSize && props.productSize.map((item,index) => {
                            return (
                                <option key={index}   value={item.size_id}>{item.size_name}</option>
                            );
                        })
                    }
                </Form.Select>
                {props && props.errorAddModal ? <p style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.size}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Product MRP</Form.Label>
                    <Form.Control type="text" 
                        onChange={(e) => props.setProductDetails({...props.productDetails , mrp:e.target.value})}
                    />
                    {props && props.errorAddModal ? <p style={{color : 'red' , fontSize : 12}}>{props.errorAddModal}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Product Price</Form.Label>
                    <Form.Control type="text" 
                        onChange={(e) => props.setProductDetails({...props.productDetails , price:e.target.value})}
                    />
                    {props && props.errorAddModal ? <p style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.price}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Product Stock</Form.Label>
                <Form.Control type="text" 
                      onChange={(e) => props.setProductDetails({...props.productDetails , stock:e.target.value})}
                />
                {props && props.errorAddModal ? <p style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.stock}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInputSKU">
                <Form.Label>SKU Code (Optional)</Form.Label>
                <Form.Control type="text" placeholder="e.g. SKU-1001"
                      onChange={(e) => props.setProductDetails({...props.productDetails , sku:e.target.value})}
                />
                {props && props.errorAddModal ? <p style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.sku}</p> : '' }
                </Form.Group>
            </Form>
        </div>
    );
};

export default AddSTockPrice;